import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { Types } from '@grandvisionhq/graphql';
import { Alert } from '@grandvisionhq/iris-ui';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { useDynamicModule } from '@grandvisionhq/utils';

const loadModule = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const storeModule = yield import(/* webpackChunkName: 'grandvisionhq-stores-v2' */ '@grandvisionhq/stores-v2');
        return storeModule;
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const usePickupStoresModule = ()=>useDynamicModule(loadModule, '@grandvisionhq/stores-v2', [])
;
const StoresFinderContainer = ({ onPickupStoreSelect , hasAttributesAsTags  })=>{
    const features = useFeatureToggles();
    const [module, loading, error] = usePickupStoresModule();
    const { getLabel  } = useIntl();
    const onStoreSelect = React.useCallback((store)=>{
        onPickupStoreSelect(store);
    }, [
        onPickupStoreSelect
    ]);
    if (loading) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (error || !module) {
        return /*#__PURE__*/ React.createElement(Alert, {
            variant: "error",
            notifyScreenReader: false,
            className: "alert-m-default"
        }, getLabel('checkout.pickupStores.error'));
    }
    const { Containers , Components , StoreFinderProvider , Util  } = module;
    const { StoreFinder , PickUpButtons , withPickUpButtonsConfig  } = Containers;
    const { StoreListTopContent  } = Components;
    const storeFilter = (store)=>Util.areServicesAvailable(store, [
            Types.ServicesNotAvailable.PICK_UP_IN_STORE
        ])
    ;
    return /*#__PURE__*/ React.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-container",
        hidePhone: !features.isStorePickupPhoneEnabled,
        hideEmail: !features.isStorePickupEmailEnabled,
        storeFilter: storeFilter
    }, /*#__PURE__*/ React.createElement(StoreFinder, {
        isInsideModal: true,
        listTopContent: /*#__PURE__*/ React.createElement(StoreListTopContent, {
            title: getLabel('checkout.component.storeListTopContent.title'),
            description: getLabel('checkout.component.storeListTopContent.description')
        }),
        buttonsComponent: withPickUpButtonsConfig(PickUpButtons, {
            onStoreSelect
        }),
        showAttributesAsTags: hasAttributesAsTags
    }));
};

export { StoresFinderContainer };
//# sourceMappingURL=StoresFinderContainer.js.map
